import styled from "styled-components";
import color from "../../assets/css/colors";

export const Row = styled.div`
`;

export const Legend = styled.legend`
    font: normal normal normal 14px Circular Std Book;
    color: ${color.tertiary};
    margin-bottom: 28px;
`;